// extracted by mini-css-extract-plugin
export default {"bg-primary-dark":"Input_bg-primary-dark__MsS+6","bg-primary-light":"Input_bg-primary-light__WOkV2","root":"Input_root__QS-GW"};